import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Instagram, Facebook, Youtube, ArrowRight } from "lucide-react";
import { navLinks } from "../mock/mock";
import { useToast } from "../hooks/use-toast";
import { subscribe as apiSubscribe } from "../lib/api";

export default function Footer() {
  const [email, setEmail] = useState("");
  const { toast } = useToast();

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await apiSubscribe(email);
      toast({
        title: "You're on the list!",
        description: "Watch your inbox for real talk, new episodes, and the good stuff.",
      });
      setEmail("");
    } catch (err) {
      toast({ title: "Something went wrong", description: "Please try again in a moment.", variant: "destructive" });
    }
  };

  return (
    <footer className="bg-navy text-cream mt-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-1">
            <div className="font-serif-display text-3xl font-bold tracking-wide">BOSSY</div>
            <div className="text-xs tracking-[0.25em] text-white/60 mt-1">KELLY &amp; KELLY · EST. 2014</div>
            <p className="font-serif-body text-lg text-white/80 mt-5 leading-relaxed">
              Two business owners who stopped waiting for a seat at the table and created a new one. Real tools, real talk.
            </p>
            <div className="flex gap-4 mt-6">
              {[Instagram, Facebook, Youtube, Mail].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-full border border-white/25 flex items-center justify-center hover:bg-teal hover:border-teal transition-colors">
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-ui font-semibold text-sm tracking-wider text-white/60 uppercase mb-5">Explore</h4>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="font-ui text-white/85 hover:text-teal transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-ui font-semibold text-sm tracking-wider text-white/60 uppercase mb-5">Resources</h4>
            <ul className="space-y-3">
              <li><Link to="/assessments" className="font-ui text-white/85 hover:text-teal transition-colors">Assessments &amp; Quizzes</Link></li>
              <li><Link to="/resources" className="font-ui text-white/85 hover:text-teal transition-colors">Resource Library</Link></li>
              <li><Link to="/guests" className="font-ui text-white/85 hover:text-teal transition-colors">Guest Directory</Link></li>
              <li><Link to="/podcast" className="font-ui text-white/85 hover:text-teal transition-colors">Podcast Episodes</Link></li>
              <li><Link to="/blog" className="font-ui text-white/85 hover:text-teal transition-colors">Blog &amp; Guides</Link></li>
              <li><Link to="/admin" className="font-ui text-white/85 hover:text-teal transition-colors">Admin Inbox</Link></li>
              <li><Link to="/speaking" className="font-ui text-white/85 hover:text-teal transition-colors">Book Us to Speak</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-ui font-semibold text-sm tracking-wider text-white/60 uppercase mb-5">Get Real, Weekly</h4>
            <p className="font-ui text-sm text-white/75 mb-4">Join the newsletter for new episodes, honest advice, and first dibs on workshops.</p>
            <form onSubmit={subscribe} className="flex items-center bg-white/10 rounded-full p-1.5 focus-within:ring-2 ring-teal">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                className="bg-transparent flex-1 px-4 py-2 text-sm text-white placeholder-white/50 outline-none"
              />
              <button type="submit" className="w-10 h-10 rounded-full bg-teal flex items-center justify-center hover:bg-white transition-colors group shrink-0">
                <ArrowRight size={18} className="text-navy" />
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/15 mt-14 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="font-ui text-sm text-white/55">© {new Date().getFullYear()} BOSSY · Kelly &amp; Kelly. All rights reserved.</p>
          <p className="font-ui text-xs text-white/40">Rochester, NY · Going national in 2025</p>
        </div>
      </div>
    </footer>
  );
}
